import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Box,
  Typography,
  Button,
  SvgIcon,
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ModalDialogVideo from 'src/components/ModalDialogVideo/index';
import { STYLE_OPTIONS } from 'src/constants';

const hostAppBannerStyles = {
  hostAppCard: {
    padding: '24px',
    marginBottom: '20px',
    background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #3730a3 100%)',
    color: '#fff',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: STYLE_OPTIONS.FONT_FAMILY,

    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-50%',
      right: '-50%',
      width: '200%',
      height: '200%',
      background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
      zIndex: 0,
    },
  },

  contentWrapper: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px',
  },

  textContent: {
    flex: '1 1 300px',
    minWidth: '300px',
  },

  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '6px',
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
  },

  subtitle: {
    fontSize: '15px',
    opacity: 0.9,
    lineHeight: 1.4,
  },

  buttonContent: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: '12px',
  },

  tutorialColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },

  videoButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: '#fff',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    padding: '12px 24px',
    borderRadius: '50px',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',

    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      border: '2px solid rgba(255, 255, 255, 0.5)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
    },
  },

  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};

const HOST_APP_TUTORIAL_VIDEO_SRC = 'https://player.vimeo.com/video/1177930797';

function HostAppBanner({ classes }) {
  const [tutorialOpen, setTutorialOpen] = useState(false);

  const handleOpenTutorial = () => setTutorialOpen(true);
  const handleCloseTutorial = () => setTutorialOpen(false);

  return (
    <>
      <Card className={classes.hostAppCard}>
        <Box className={classes.contentWrapper}>
          <Box className={classes.textContent}>
            <Typography className={classes.title}>
              📱 The CP Host App
            </Typography>
            <Typography className={classes.subtitle}>
              Your hosts can now manage invites, RSVPs, and orders right from their phone.
              Watch the tutorial to see how it works!
            </Typography>
          </Box>
          <Box className={classes.buttonContent}>
            <Box className={classes.tutorialColumn}>
              <Button
                className={classes.videoButton}
                onClick={handleOpenTutorial}
                size="large"
              >
                <Box className={classes.iconWrapper}>
                  <SvgIcon component={PlayArrowIcon} />
                  Watch Tutorial
                  <SvgIcon component={OndemandVideoIcon} />
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>
      </Card>

      <ModalDialogVideo
        onClose={handleCloseTutorial}
        isVisible={tutorialOpen}
        videosrc={HOST_APP_TUTORIAL_VIDEO_SRC}
        title="The CP Host App"
        largeModal
      />
    </>
  );
}

HostAppBanner.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(HostAppBanner, hostAppBannerStyles);
